import * as React from 'react';
import { observer } from 'mobx-react';
import ModalReactions from '../../../../../Modal/ModalReactions';
import ExeconlineCatalogModal, { Props } from './ExeconlineCatalogModal';

const ExeconlineCatalogDetails: React.FC<Props> = (props) => (
  <>
    <ExeconlineCatalogModal {...props} />
    <ModalReactions store={props.modalStore} />
  </>
);

export default observer(ExeconlineCatalogDetails);
